import MeasurementRepository from './measurementsRepository'
import MeasurementTypeRepository from './measurementTypesRepository'

export default {
    MeasurementRepository,
    MeasurementTypeRepository
}
